import { DateTime, DurationInput } from "luxon";

/**
 * Gets date relative to current date.
 * @param {string} dateUnit - Duration type. Possible values "year", "month", "day".
 * @param {number} value - Relative value. Example -1, 10, 5 etc.
 */
export function getDateRelativeToCurrentDate(dateUnit: 'day' | 'month' | 'year', value: number): DateTime {
  const today = DateTime.now().reconfigure({ locale: 'en-AU' });
  const duration: DurationInput = {};
  switch (dateUnit) {
    case 'year': {
      duration.years = value;
      break;
    }
    case 'month': {
      duration.months = value;
      break;
    }
    case 'day': {
      duration.days = value;
      break;
    }
  }
  return today.plus(duration).setZone(today.zoneName).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).reconfigure({ locale: 'en-AU' });
}

export function getDateFromDDMMYYYYString(date: string): Date | null {
  if (date) {
    const splitDate = date.split('/');
    if (splitDate.length === 3) {
      const day = parseInt(splitDate[0], 10);
      const month = parseInt(splitDate[1], 10) - 1; // Months are 0-based
      const year = parseInt(splitDate[2], 10);

      // Create and return the Date object in UTC
      const returnDate = new Date(Date.UTC(year, month, day));
      return returnDate;
    }
  }
  return null;
}
